import { useState, useEffect } from "react";

// Components
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Latestupdate from "../Component/Latestupdate/Latestupdate";
import AuctionCardNFT from "Component/AuctionCard/AuctionCard";
import UpComingNft from "Component/UpComingAuction/UpCominng";
import SecondrySaleNft from "Component/SecondrySaleNft/SecondrySale";

// Pages
import Homebanner from "../Pages/Home/Homebanner";
import DigitalArtcollection from "../Pages/Home/DigitalArtcollection";
import Nftdescription from "../Pages/Home/Nftdescription";
import BrowseByCategory from "../Pages/Home/Upcomingauction";
import Blogsection from "../Pages/Home/Blogsection";
import TopMuseumsNFT from "Component/TopMuseum/TopMuseums";
import TrandingArtist from "Component/TrandingArtist/TransingArtist";
import { Link } from "react-router-dom";
import TopSales from "Pages/Home/TopSales";
import ResentList from "Pages/Home/RecentList";
import TrendingNFT from "Pages/Home/TrendingNFT";
import ArtSlider from "Pages/Home/ArtSlider";
import Stayintheloop from "Pages/Home/Stayintheloop";
import { Oval } from "react-loader-spinner";
import { useSelector } from "react-redux";

const HomeTheme = () => {
  const [showButton, setShowButton] = useState(false);
  const { loading } = useSelector((state) => state?.SellItems);
  const [pageLoading, setLaoding] = useState(true)
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });

    setTimeout(() => {
      setLaoding(false)
    }, 3000)
  }, []);
  const [eventData, setEventData] = useState('Traditional Art');
  const [eventId, setEventId] = useState('63a3f8ca3afc27eac9e49068');

  // Event handler to receive data from ChildComponent1 and pass to ChildComponent2
  const handleEventFromChild1 = (data, id) => {
    setEventData(data);
    setEventId(id);
  };
  return (
    <>
      {(loading || pageLoading) &&
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }
      <div className="position-relative">
        <Header />
        <div className="gradientBgHome pt-5">
          <DigitalArtcollection eventData={eventData} eventId={eventId} />
        </div>
        <TopSales />

        <AuctionCardNFT handleEventFromChild1={handleEventFromChild1} />

        <ResentList />
        {/* <TrendingNFT /> */}
        <Stayintheloop />
        <Footer />
      </div>
    </>
  );
};
export default HomeTheme;
